import {useState,useEffect} from "react";
import schedulePayService from '../../services/SchedulePayService';

const formatCurrency = (value) => {
    return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
    }).format(value);
};

export default function TotalPayments({reloadTotals,totalsView,currentYear}) {
    const [totalsInvoice, setTotalsInvoice] = useState({
        withInvoice: 0,
        withOutInvoice: 0,
        sumTotal:0
    });

    useEffect(() => {
        schedulePayService.getTotalsByYear(currentYear)
            .then(res => {
                setTotalsInvoice({
                    withInvoice: Number(res.data.withInvoice),
                    withOutInvoice: Number(res.data.withOutInvoice),
                    sumTotal: Number(res.data.withInvoice) + Number(res.data.withOutInvoice)
                });
            })
        .catch(console.error);
    }, [reloadTotals,currentYear]);

  	return (
  	    <>
        <div className="card mb-6">
            <div className="card-body pt-3 pb-3">
                <div className="row gy-4 gy-sm-1">
                    <div className="col-sm-6 col-lg-2 offset-1">
                        <div className="d-flex justify-content-between align-items-start border-end pb-4 pb-sm-0">
                            <div>
                                <h4 className="mb-0">{formatCurrency(totalsInvoice.withInvoice)}</h4>
                                <p className="mb-0">Fatture emesse</p>
                            </div>
                        </div>
                        <hr className="d-none d-sm-block d-lg-none me-6" />
                    </div>
                    <div className="col-sm-6 col-lg-2">
                        <div className="d-flex justify-content-between align-items-start border-end pb-4 pb-sm-0">
                            <div>
                                <h4 className="mb-0">{formatCurrency(totalsInvoice.withOutInvoice)}</h4>
                                <p className="mb-0">Fatture da emettere</p>
                            </div>
                        </div>
                        <hr className="d-none d-sm-block d-lg-none me-6" />
                    </div>
                    <div className="col-sm-6 col-lg-2">
                        <div className="d-flex justify-content-between align-items-start border-end pb-4 pb-sm-0">
                            <div>
                                <h4 className="mb-0">{formatCurrency(totalsInvoice.sumTotal)}</h4>
                                <p className="mb-0">Fatturato annuo</p>
                            </div>
                        </div>
                        <hr className="d-none d-sm-block d-lg-none me-6" />
                    </div>
                    <div className="col-sm-6 col-lg-2">
                        <div className="d-flex justify-content-between align-items-start border-end">
                            <div>
                                <h4 className="mb-0">{formatCurrency(totalsView.withIva)}</h4>
                                <p className="mb-0">Lordo visualizzato</p>
                            </div>
                        </div>
                        <hr className="d-none d-sm-block d-lg-none me-6" />
                    </div>
                    <div className="col-sm-6 col-lg-2">
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <h4 className="mb-0">{formatCurrency(totalsView.withOutIva)}</h4>
                                <p className="mb-0">Netto visualizzato</p>
                            </div>
                        </div>
                        <hr className="d-none d-sm-block d-lg-none me-6" />
                    </div>
                </div>
            </div>
        </div>
        </>
	);
}